<!-- #region Navbar -->
<app-nav></app-nav>
<!-- endregion -->

<router-outlet></router-outlet>
